import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import styles from './alkReport.module.scss';
import Survey from './survey';
import Completed from './completed';
import Result from './result';
import Degree from './degree';
import InputDialog from '../AlkComponent/inputDialog';
import right_db_arrow from '../../static/images_ae/alkReport/right_db_arrow.png';
import blue_body from '../../static/images_ae/alkReport/blue_body.png';
import icon_down_down from '../../static/images_ae/alkReport/icon_down_down.png';
import btn_six_side from '../../static/images_ae/alkReport/btn_six_side.png';
import trapezoid_left from '../../static/images_ae/alkReport/trapezoid_left.png';
import trapezoid_right from '../../static/images_ae/alkReport/trapezoid_right.png';
import rt_delete_arrow from '../../static/images_ae/alkReport/rt_delete_arrow.png';
import number_1_white from '../../static/images_ae/alkReport/number_1_white.png';
import number_2_white from '../../static/images_ae/alkReport/number_2_white.png';
import number_3_white from '../../static/images_ae/alkReport/number_3_white.png';
import number_1_blue from '../../static/images_ae/alkReport/number_1_blue.png';
import number_2_blue from '../../static/images_ae/alkReport/number_2_blue.png';
import number_3_blue from '../../static/images_ae/alkReport/number_3_blue.png';
import number_1_purple from '../../static/images_ae/alkReport/number_1_purple.png';
import number_2_purple from '../../static/images_ae/alkReport/number_2_purple.png';
import number_3_purple from '../../static/images_ae/alkReport/number_3_purple.png';
import step_checked from '../../static/images_ae/alkReport/step_checked.png';

const api = new ApiCore();

const colors = {
    purple: '#5F2CB7',
    blue: '#213CCC',
    white: '#FFFFFF',
}

let otherCodeId = 1;

const AlkReport = (props: any) => {

    const [leftOrgans, setLeftOrgans] = useState<any>([]);
    const [rightOrgans, setRightOrgans] = useState<any>([]);
    const [activeBgImg, setActiveBgImg] = useState<any>('');
    const [treatments, setTreatmentsList] = useState<any>([]);
    const [showBody, setShowBody] = useState<any>(false);
    const [showSurvey, setShowSurvey] = useState<any>(false);
    const [showDegree, setShowDegree] = useState<any>(false);
    const [showCompleted, setShowCompleted] = useState<any>(false);
    const [showResult, setShowResult] = useState<any>(false);
    const [isDefautImg, setIsDefautImg] = useState<any>(false);
    const [bodySelectedCount, setBodySelectedCount] = useState<number>(0);
    const [selectedCount, setSelectedCount] = useState<number>(0);
    const [symptomsResult, setSymptomsResult] = useState<any>([]);
    const [commonSymptoms, setCommonSymptoms] = useState<any>([]);
    const [symptomRecords, setSymptomsRecords] = useState<any>([]);
    const [isCommonSymptoms, setIsCommonSymptoms] = useState<any>(true);
    const [nowStep, setNowStep] = useState<any>(1);
    const [organsMap, setOrgansMap] = useState<any>([]);
    const [activeCode, setActiveCode] = useState<any>('');
    const [allSymptoms, setAllSymptoms] = useState<any>([]);
    const [historyAllSymptoms, setHistoryAllSymptoms] = useState<any>([]); // 历史选中过的症状
    const [activeOrganName, setActiveOrganName] = useState<any>('');
    const [investigation, setInvestigation] = useState<any>([]);
    const [otherDialogContent, setOtherDialogContent] = useState<string>('')
    const [otherDialogPlaceholder, setOtherDialogPlaceholder] = useState<string>('')
    const [activeQIndex, setActiveQIndex] = useState<any>(-1)
    const [showOtherDialog, setShowOtherDialog] = useState<boolean>(false)

    useEffect(() => {
        window.document.title = 'ALK肺癌慢病管理风险评估';
        initData();
        return () => {
        }
    }, [])

    useEffect(() => {
        const _showBody = [showCompleted, showResult, showDegree, showSurvey].every((val: any) => !val);
        // setShowBody(_showBody);
        if (nowStep == 2) {
            setShowBody(true);
        } else {
            setShowBody(false);
        }
    }, [showSurvey, showCompleted, showResult, showDegree, nowStep])

    const initData = () => {
        api.getEvaluationConfig().then((res: any) => {
            if (res.code == 0) {
                // 之前选择过的作为记录
                let savedItemBefore: any = {};
                let saved_data = localStorage.getItem('alk_report_saved_data');
                if (saved_data) {
                    savedItemBefore = JSON.parse(saved_data);
                }
                let mAllSymptoms = savedItemBefore.allSymptoms || [];
                setHistoryAllSymptoms(mAllSymptoms);
                // 治疗方案
                setTreatmentsList(res.data?.treatments || []);
                // 症状
                let _commonSymptoms: any = [];
                let _organs = res.data?.organs || [];
                _organs = _organs.map((val: any) => {
                    let remarkCount = 0;
                    const symptoms = val.symptoms.map((vv: any) => {
                        if (vv.remark) {
                            remarkCount++;
                        }
                        if (vv.isTop) {
                            _commonSymptoms.push(vv);
                        }
                        return {
                            ...vv,
                            organName: val.name,
                            positionCode: val.positionCode,
                            positionName: '',
                            remarkCount
                        };
                    });
                    if (symptoms[0] && symptoms[0].organCode) {
                        // 之前添加过的其他选项
                        let addedBefore = mAllSymptoms.filter((v: any) => v.organCode == symptoms[0].organCode && v.type === 'addedByOther');
                        if (addedBefore && addedBefore.length > 0) {
                            addedBefore.forEach((val: any) => {
                                symptoms.push({
                                    ...val
                                });
                            });
                        }
                        // 其他
                        symptoms.push({
                            organName: val.name,
                            positionCode: val.positionCode,
                            code: '',
                            isTop: null,
                            levelType: 1,
                            type: 'other',
                            name: '其他',
                            organCode: symptoms[0].organCode,
                            remark: null,
                            scaleCode: '',
                            scaleVersion: '',
                            remarkCount
                        });
                    }
                    return {
                        ...val,
                        symptoms
                    };
                });
                // 所有器官映射
                const _organsMap = {};
                _organs.forEach((val: any) => {
                    _organsMap[val.code] = val;
                });
                // 反选之前选中过的
                // 切割
                let _average = Math.floor(_organs.length / 2);
                let _leftOrgans = _organs.slice(0, _average);
                _leftOrgans = JSON.parse(JSON.stringify(_leftOrgans));
                let _rightOrgans = _organs.slice(_average, _organs.length);
                _rightOrgans = JSON.parse(JSON.stringify(_rightOrgans));
                mAllSymptoms.forEach((val: any, key: number) => {
                    _leftOrgans = _leftOrgans.map((lv: any, lk: number) => {
                        if (val.organCode == lv.code) {
                            if (lv.selectedCount !== undefined) {
                                lv.selectedCount++;
                            } else {
                                lv.selectedCount = 1;
                            }
                            if (key == mAllSymptoms.length - 1) {
                                lv.selected = true;
                            }
                        }
                        return {
                            ...lv
                        }
                    });
                    _rightOrgans = _rightOrgans.map((rv: any, rk: number) => {
                        if (val.organCode == rv.code) {
                            if (rv.selectedCount !== undefined) {
                                rv.selectedCount++;
                            } else {
                                rv.selectedCount = 1;
                            }
                            if (key == mAllSymptoms.length - 1) {
                                rv.selected = true;
                            }
                        }
                        return {
                            ...rv
                        }
                    });
                    // 症状选中初始化
                    if (val.organCode) {
                        let oIndex = _organsMap[val.organCode].symptoms.findIndex((ov: any) => {
                            if (val.code == ov.code) {
                                return true;
                            }
                            return false;
                        });
                        // 选中过
                        if (oIndex >= 0) {
                            _organsMap[val.organCode].symptoms[oIndex].selected = true;
                            if (_organsMap[val.organCode].selectedCount !== undefined) {
                                _organsMap[val.organCode].selectedCount = _organsMap[val.organCode].selectedCount + 1;
                            } else {
                                _organsMap[val.organCode].selectedCount = 1;
                            }
                        }
                        // 最后一个
                        if (key == mAllSymptoms.length - 1) {
                            _organsMap[val.organCode].selected = true;
                            setActiveCode(val.organCode);
                            setActiveOrganName(val.organName);
                            setActiveBgImg(_organsMap[val.organCode].picture);
                            setIsCommonSymptoms(false);
                        }
                    }
                    // 常见症状反选
                    _commonSymptoms = _commonSymptoms.map((cv: any) => {
                        if (cv.code == val.code) {
                            return {
                                ...cv,
                                selected: true
                            }
                        } else {
                            return {
                                ...cv
                            }
                        }
                    });
                });
                setCommonSymptoms(_commonSymptoms);
                setSelectedCount(mAllSymptoms.length);
                setAllSymptoms(mAllSymptoms)
                setLeftOrgans(_leftOrgans);
                setRightOrgans(_rightOrgans);
                setOrgansMap(_organsMap);
                // 问卷调研还原
                if (savedItemBefore.investigation) {
                    setInvestigation(savedItemBefore.investigation);
                }
                // 步骤还原
                let nowStep = savedItemBefore.nowStep;
                if (nowStep && nowStep >= 1) {
                    setNowStep(nowStep);
                    if (nowStep == 1) {
                        setShowSurvey(true);
                    } else if (nowStep == 2) {
                        setShowBody(true);
                    } else if (nowStep == 3) {
                        setShowDegree(true);
                    }
                } else {
                    setNowStep(1);
                    setShowSurvey(true);
                }
            }
        })
    }

    const onBack = () => {
        setShowCompleted(false);
        setShowResult(false);
        setShowDegree(false);
        let _step = nowStep;
        if (_step > 1) {
            _step--;
            setNowStep(_step)
            // 返回时更新当前所在步骤
            saveAllSymptoms(allSymptoms, _step);
        }
    }

    // 症状选择
    const symptomSelected = (val: any, extraUpdate = true) => {
        if (val.type == 'other') {
            // 选其他
            toShowOtherDialog('');
            return;
        }
        const _allSymptoms: any = [];
        let count = 0;
        let _activeCode = val.organCode;
        const _symptoms = organsMap[_activeCode].symptoms.map((v: any) => {
            let selected = v.selected;
            if (v.code == val.code) {
                selected = !v.selected;
            }
            if (selected) {
                count++;
            }
            return {
                ...v,
                selected
            }
        })
        let _organsMap = JSON.parse(JSON.stringify(organsMap));
        _organsMap[_activeCode].symptoms = _symptoms;
        _organsMap[_activeCode].selectedCount = count;
        let allSelected = 0;
        Object.values(_organsMap).forEach((vv: any) => {
            vv.symptoms.forEach((vvv: any) => {
                if (vvv.selected) {
                    _allSymptoms.push(vvv);
                    allSelected++;
                }
            });
        })
        const _leftOrgans = leftOrgans.map((val: any) => {
            if (_organsMap[val.code]) {
                let selectedCount = 0;
                selectedCount = _organsMap[val.code].selectedCount;
                return {
                    ...val,
                    selectedCount 
                }
            }
            return val;
        });
        const _rightOrgans = rightOrgans.map((val: any) => {
            if (_organsMap[val.code]) {
                let selectedCount = 0;
                selectedCount = _organsMap[val.code].selectedCount;
                return {
                    ...val,
                    selectedCount 
                }
            }
            return val;
        });
        setLeftOrgans(_leftOrgans);
        setRightOrgans(_rightOrgans);
        setSelectedCount(allSelected);
        setOrgansMap(_organsMap);
        // 同步常见症状
        if (extraUpdate) {
            commonSymptomsSelected(val, false);
        }
        // 记录所有症状
        setAllSymptoms(_allSymptoms);
        saveAllSymptoms(_allSymptoms);
    }

    // 常见症状选择
    const commonSymptomsSelected = (val: any, extraUpdate = true) => {
        const _commonSymptoms = commonSymptoms.map((v: any) => {
            let selected = v.selected;
            if (v.code == val.code) {
                selected = !v.selected;
            }
            return {
                ...v,
                selected
            }
        })
        setCommonSymptoms(_commonSymptoms);
        // 同步正常症状选项
        if (extraUpdate) {
            symptomSelected(val, false);
        }
    }

    // 存储选中过的数据。
    const saveAllSymptoms = (allSymptoms: any, curStep?: any) => {
        let savedItemBefore = {};
        let saved_data = localStorage.getItem('alk_report_saved_data');
        if (saved_data) {
            savedItemBefore = JSON.parse(saved_data);
        }
        let _mNowStep = nowStep;
        if (curStep) {
            _mNowStep = curStep;
        }
        const savedItem = {
            ...savedItemBefore,
            nowStep: _mNowStep,
            allSymptoms: allSymptoms ? allSymptoms : []
        }
        localStorage.setItem('alk_report_saved_data', JSON.stringify(savedItem));
    }

    // 删除所选症状
    const toDeleteSymptom = (val: any) => {
        allSymptomSelected(val);
    }

    // 症状选择
    const allSymptomSelected = (val: any, extraUpdate = true) => {
        const _allSymptoms: any = [];
        let _organsMap = JSON.parse(JSON.stringify(organsMap));
        const _map = {};
        for (let key in _organsMap) {
            let item = _organsMap[key];
            let count = 0;
            const _symptoms = item.symptoms.map((v: any) => {
                let selected = v.selected;
                if (v.code == val.code) {
                    selected = !v.selected;
                }
                if (selected) {
                    count++;
                }
                return {
                    ...v,
                    selected
                }
            })
            _map[key] = {
                symptoms: _symptoms,
                selectedCount: count
            }
        }
        for (let key in _map) {
            let item = _map[key];
            _organsMap[key].symptoms = item.symptoms;
            _organsMap[key].selectedCount = item.selectedCount;
        }
        let allSelected = 0;
        Object.values(_organsMap).forEach((vv: any) => {
            vv.symptoms.forEach((vvv: any) => {
                if (vvv.selected) {
                    _allSymptoms.push(vvv);
                    allSelected++;
                }
            });
        })
        const _leftOrgans = leftOrgans.map((val: any) => {
            if (_organsMap[val.code]) {
                let selectedCount = 0;
                selectedCount = _organsMap[val.code].selectedCount;
                return {
                    ...val,
                    selectedCount 
                }
            }
            return val;
        });
        const _rightOrgans = rightOrgans.map((val: any) => {
            if (_organsMap[val.code]) {
                let selectedCount = 0;
                selectedCount = _organsMap[val.code].selectedCount;
                return {
                    ...val,
                    selectedCount 
                }
            }
            return val;
        });
        setLeftOrgans(_leftOrgans);
        setRightOrgans(_rightOrgans);
        setSelectedCount(allSelected);
        setOrgansMap(_organsMap);
        // 同步常见症状
        if (extraUpdate) {
            commonSymptomsSelected(val, false);
        }
        // 记录所有症状
        setAllSymptoms(_allSymptoms);
        saveAllSymptoms(_allSymptoms);
    }

    const toComplete = () => {
        if (selectedCount > 0) {
            let _nowStep = nowStep;
            _nowStep++;
            setNowStep(_nowStep);
            setShowBody(false);
            setShowDegree(true);
            saveAllSymptoms(allSymptoms, _nowStep); // 记录至于下一步
        } else {
            Toast.show('请先选择症状', 0.8);
        }
    }
    
    const onInvestigationComplete = (data: any) => {
        setInvestigation(data);
        setNowStep(2);
        setShowSurvey(false);
        setShowBody(true);
    }

    const onDegreeComplete = (data: any) => {
        let _nowStep = nowStep;
        if (_nowStep <= 3) {
            _nowStep++;
            setNowStep(_nowStep);
        }
        setSymptomsRecords(data);
        // setShowDegree(false);

        
        // setShowCompleted(true);
    }

    const onCompletedFinished = (data: any) => {
        setSymptomsResult(data || {});
        setShowCompleted(false);
        setShowBody(false);
        // setShowResult(true);
        sessionStorage.setItem('SymptomsResultData', JSON.stringify(data));
        props.history.push('/alk/reportResult');
    }

    const allComplete= (data: any) => {
        setSymptomsResult(data || {});
        sessionStorage.setItem('SymptomsResultData', JSON.stringify(data));
        // 清除历史状态
        localStorage.removeItem('alk_report_saved_data');
        props.history.replace('/alk/reportResult');
    }

    const orgransActive = (val: any, type: string) => {
        // 会取消
        // setIsDefautImg(val.selected);
        setActiveBgImg(val.selected ? '' : val.picture);
        setActiveCode(val.selected ? '' : val.code);
        let hasSelected = false;
        let _name = val.name;
        if (type === 'left') {
            let _leftOrgans = leftOrgans.map((v: any) => {
                let selected = false;
                if (val.code == v.code) {
                    selected = !v.selected;
                    if (!selected) {
                        _name = '';
                    }
                }
                if (selected) {
                    hasSelected = true;
                }
                return {
                    ...v,
                    selected
                }
            });
            let _rightOrgans = rightOrgans.map((v: any) => {
                let selected = false;
                return {
                    ...v,
                    selected
                }
            });
            setLeftOrgans(_leftOrgans);
            setRightOrgans(_rightOrgans);
        } else if (type === 'right') {
            let _rightOrgans = rightOrgans.map((v: any) => {
                let selected = false;
                if (val.code == v.code) {
                    selected = !v.selected;
                    if (!selected) {
                        _name = '';
                    }
                }
                if (selected) {
                    hasSelected = true;
                }
                return {
                    ...v,
                    selected
                }
            });
            let _leftOrgans = leftOrgans.map((v: any) => {
                let selected = false;
                return {
                    ...v,
                    selected
                }
            });
            setLeftOrgans(_leftOrgans);
            setRightOrgans(_rightOrgans);
        }
        setActiveOrganName(_name);
        setIsCommonSymptoms(!hasSelected);
    }

    const renderBg = () => {
        // O009 O010 O012 -> 身体伸展
        // O001 O002 -> 头部
        // 其余 -> 身体
        let _class = styles.middle_area_body;
        if (activeCode == 'O009' || activeCode == 'O010' || activeCode == 'O012') {
            _class = styles.middle_area_body_expand;
        } else if (activeCode == 'O001' || activeCode == 'O002') {
            _class = styles.middle_area_body_head;
        }
        return _class;
    }

    const renderIconWidth = (val: any) => {
        let code = val.code;
        let _num = 20;
        if (code == 'O001') {
            _num = 12.13;
        } else if (code == 'O002') {
            _num = 13.04;
        } else if (code == 'O003') {
            _num = 13.17;
        } else if (code == 'O004') {
            _num = 11.13;
        } else if (code == 'O005') {
            _num = 13.29;
        } else if (code == 'O006') {
            _num = 13.46;
        } else if (code == 'O007') {
            _num = 13.93;
        } else if (code == 'O008') {
            _num = 9.78;
        } else if (code == 'O009') {
            _num = 7.91;
        } else if (code == 'O010') {
            _num = 14;
        } else if (code == 'O011') {
            _num = 11.14;
        } else if (code == 'O012') {
            _num = 6.75;
        } else if (code == 'O013') {
            _num = 8.84;
        } else if (code == 'O014') {
            _num = 12.14;
        }
        return _num;
    }

    const renderIconHeight = (val: any) => {
        let code = val.code;
        let _num = 20;
        if (code == 'O001') {
            _num = 11.52;
        } else if (code == 'O002') {
            _num = 9.18;
        } else if (code == 'O003') {
            _num = 13.04;
        } else if (code == 'O004') {
            _num = 11.52;
        } else if (code == 'O005') {
            _num = 11.3;
        } else if (code == 'O006') {
            _num = 10.36;
        } else if (code == 'O007') {
            _num = 12.18;
        } else if (code == 'O008') {
            _num = 12.18;
        } else if (code == 'O009') {
            _num = 11.52;
        } else if (code == 'O010') {
            _num = 13.12;
        } else if (code == 'O011') {
            _num = 13.97;
        } else if (code == 'O012') {
            _num = 14.69;
        } else if (code == 'O013') {
            _num = 13.37;
        } else if (code == 'O014') {
            _num = 13.44;
        }
        return _num;
    }

    const onClose = () => {
        setOtherDialogContent('');
        setOtherDialogPlaceholder('');
        setShowOtherDialog(false);
        setActiveQIndex(-1);
    }

    const onSave = (value: any) => {
        setOtherDialogContent(value);
        setOtherDialogPlaceholder('');
        toCompleteValue(value);
        setShowOtherDialog(false);
        setActiveQIndex(-1);
    }

    const toShowOtherDialog = (placeholder: string) => {
        setOtherDialogPlaceholder(placeholder);
        setShowOtherDialog(true);
    }

    const toCompleteValue = (value: any) => {
        const _allSymptoms: any = [];
        let count = 0;
        let _activeCode = activeCode;
        let _symptoms = organsMap[_activeCode].symptoms.map((v: any) => v);
        const _other = _symptoms.pop();
        // 历史已加入过
        while (historyAllSymptoms.some((vv: any) => vv.code == otherCodeId)) {
            otherCodeId++;
        }
        _symptoms.push({
            ..._other,
            code: otherCodeId,
            type: 'addedByOther',
            name: value,
            selected: true,
        }, _other);
        otherCodeId++;
        _symptoms = _symptoms.map((v: any) => {
            let selected = v.selected;
            if (selected) {
                count++;
            }
            return {
                ...v,
                selected
            }
        })
        let _organsMap = JSON.parse(JSON.stringify(organsMap));
        _organsMap[_activeCode].symptoms = _symptoms;
        _organsMap[_activeCode].selectedCount = count;
        let allSelected = 0;
        Object.values(_organsMap).forEach((vv: any) => {
            vv.symptoms.forEach((vvv: any) => {
                if (vvv.selected) {
                    _allSymptoms.push(vvv);
                    allSelected++;
                }
            });
        })
        const _leftOrgans = leftOrgans.map((val: any) => {
            if (_organsMap[val.code]) {
                let selectedCount = 0;
                selectedCount = _organsMap[val.code].selectedCount;
                return {
                    ...val,
                    selectedCount 
                }
            }
            return val;
        });
        const _rightOrgans = rightOrgans.map((val: any) => {
            if (_organsMap[val.code]) {
                let selectedCount = 0;
                selectedCount = _organsMap[val.code].selectedCount;
                return {
                    ...val,
                    selectedCount 
                }
            }
            return val;
        });
        setLeftOrgans(_leftOrgans);
        setRightOrgans(_rightOrgans);
        setSelectedCount(allSelected);
        setOrgansMap(_organsMap);
        // 记录所有症状
        setAllSymptoms(_allSymptoms);
        saveAllSymptoms(_allSymptoms);
    }

    return (
        <div className={styles.ae_reporting}>
            {
                !showResult &&
                <div className={styles.alk_head}>
                    <div className={styles.alk_head_item_active}>
                        <div className={styles.number_wrap}>
                            {
                                nowStep <= 1 ?
                                <div className={styles.number}>1</div>
                                :
                                <div className={`${styles.step_checked}`}> 
                                    <img src={step_checked} />
                                </div>
                            }
                        </div>
                        <div className={`${styles.title_choose} ${ nowStep == 1 ? styles.actived : ''} `}>现状调研</div>
                        <div className={styles.title_desc}>您的病情调研</div>
                    </div>
                    <div>
                        <img src={right_db_arrow} alt="" />
                    </div>
                    <div className={`${nowStep >= 2 ? styles.alk_head_item_active : styles.alk_head_item}`}>
                        <div className={styles.number_wrap}>
                            {
                                nowStep <= 2 ?
                                <div className={styles.number}>2</div>
                                :
                                <div className={`${styles.step_checked}`}> 
                                    <img src={step_checked} />
                                </div>
                            }
                        </div>
                        <div className={`${styles.title_choose} ${ nowStep == 2 ? styles.actived : ''} `}>选择症状</div>
                        <div className={styles.title_desc}>选择您的症状</div>
                    </div>
                    <div className={`${nowStep >= 3 ? '' : styles.not_actice}`}>
                        <img src={right_db_arrow} alt="" />
                    </div>
                    <div className={`${nowStep >= 3 ? styles.alk_head_item_active : styles.alk_head_item}`}>
                        <div className={styles.number_wrap}>
                            {
                                nowStep <= 3 ?
                                <div className={styles.number}>3</div>
                                :
                                <div className={`${styles.step_checked}`}> 
                                    <img src={step_checked} />
                                </div>
                            }
                        </div>
                        <div className={`${styles.title_choose} ${ nowStep == 3 ? styles.actived : ''} `}>程度判定</div>
                        <div className={styles.title_desc}>症状程度补充</div>
                    </div>
                    <div  className={`${nowStep >= 4 ? '' : styles.not_actice}`}>
                        <img src={right_db_arrow} alt="" />
                    </div>
                    <div className={`${nowStep >= 4 ? styles.alk_head_item_active : styles.alk_head_item}`}>
                        <div className={styles.number_wrap}>
                            <div className={styles.number}>4</div>
                        </div>
                        <div className={styles.title_choose}>评测结果</div>
                        <div className={styles.title_desc}>查看测评结果</div>
                    </div>
                </div>
            }
            {/* 选择常见症状 */}
            {
                showBody && 
                <div className={styles.choose_sympton}>
                    <div className={styles.content_area}>
                        <div className={styles.sympton_title}>
                            最近三个月内，您在治疗后是否出现如下方面
                            {
                                activeOrganName &&
                                <span>【{activeOrganName}】</span>

                            }
                            相关症状或问题？（可多选）
                        </div>
                        <div className={styles.sympton_content}>
                            {
                                (!isCommonSymptoms ? organsMap[activeCode]?.symptoms : commonSymptoms).map((v: any, key: number) => {
                                    let countImg = '';
                                    if (!isCommonSymptoms && v.remark) {
                                        if (v.remarkCount == 1) {
                                            countImg = v.selected ? number_1_white : number_1_purple;
                                        } else if (v.remarkCount == 2) {
                                            countImg = v.selected ? number_2_white : number_2_purple;
                                        } else if (v.remarkCount == 3) {
                                            countImg = v.selected ? number_3_white : number_3_purple;
                                        }
                                    }
                                    return (
                                        <div className={`${v.selected ? styles.active : styles.un_active} ${styles.base_item} ${v.name.length > 5 ? styles.db_item : ''}`} key={key} onClick={() => { 
                                            if (!isCommonSymptoms ) {
                                                symptomSelected(v)
                                            } else {
                                                commonSymptomsSelected(v)
                                            }
                                        }}>
                                            <span>{v.name}</span>
                                            {
                                                !isCommonSymptoms && v.remark && 
                                                <img src={countImg} alt="" />
                                            }
                                        </div>
                                    )
                                })
                            }
                            {!isCommonSymptoms && organsMap[activeCode] && organsMap[activeCode].symptoms[organsMap[activeCode].symptoms.length - 1].remarkCount > 0 &&
                            <div className={styles.sympton_remark}>
                                <div className={styles.sympton_remark_top}>
                                    {
                                        organsMap[activeCode].symptoms.filter((v: any) => v.remark).map((vv: any, kk: number)=> (
                                            <div className={styles.remark_tip_item}>
                                                <img src={kk == 0 ? number_1_blue : kk == 1 ? number_2_blue : number_3_blue} alt="" />
                                                <span>{vv.remark}</span>
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className={styles.sympton_remark_bottom}></div>
                            </div>
                            }

                        </div>

                    </div>
                </div>
            }
            {/* 选择身体部位症状 */}
            {
                showBody &&
                <div className={styles.ae_reporting_content}>
                    { 
                        bodySelectedCount > 0 ?
                        // <div className={styles.body_title}>
                        //     <div className={styles.body_active}>全部</div>
                        //     <div className={styles.body_un_active}>{
                        //         headSelected ? 
                        //         '头颈': stomachSelected ?
                        //         '腹部': chestSelected ?
                        //         '胸部': fourLimbsSelected ?
                        //         '四肢': othersSelected ?
                        //         '其他': ''
                        //     }</div>
                        //     <div className={styles.body_un_active}>未选器官</div>
                        // </div>
                        <></>
                        :
                        <div className={styles.body_title}>
                            <img src={icon_down_down} alt="" />
                            <span>更多症状请选择部位或器官</span>
                            <img src={icon_down_down} alt="" />
                        </div>
                    }
                    <div className={styles.area_body_container}>
                        <div className={styles.body_wrap}> 
                            <div className={styles.body_left}>
                                <img className={styles.bg_img} src={trapezoid_left} alt="" />
                                {
                                    leftOrgans.map((val: any, key: number) => (
                                        <div key={key} className={styles.left_trapezoid_wrap} onClick = { () => { orgransActive(val, 'left') }}>
                                            <div className={styles.icon_img_text_wrap} 
                                                style={{left: `${key * 4}px`}}
                                            >
                                                <div className={styles.icon_img} style={{
                                                    position: 'absolute',
                                                    left: '5px',
                                                    top: '50%',
                                                    transform: 'translate(0, -50%)',
                                                    zIndex: 2,
                                                    display: 'inline-block',
                                                    width: `${renderIconWidth(val)}px`,
                                                    height: `${renderIconHeight(val)}px`,
                                                    WebkitMaskImage: `url(${val.icon})`,
                                                    WebkitMaskSize: 'contain',
                                                    backgroundColor: val.selected ? colors.white : val.selectedCount ? colors.blue : colors.purple,
                                                    maskImage: `url(${val.icon})`,
                                                    maskSize: 'contain',
                                                }}>
                                                </div>
                                                <div className={`${styles.left_text}`} style={{ color: val.selected ? colors.white : val.selectedCount ? colors.blue : colors.purple}} >
                                                    {val.name}
                                                </div>
                                            </div>

                                            <div className={styles.left_trapezoid}>
                                                <div className={`${styles.left_item_rect_base} ${styles['left_item_rect' + key ]} ${val.selected ? styles.item_selected_rect : ''}`}>
                                                    <div className={organsMap[val.code]?.selectedCount ? styles.count_bg : styles.count_bg_none}>{organsMap[val.code]?.selectedCount ? organsMap[val.code]?.selectedCount : ''}</div>
                                                </div>
                                                <div className={`${styles.left_item_triangle} ${val.selected ? styles.item_selected_triangle : ''}`}>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className={styles.body_middle}>
                                <img className={renderBg()} src={activeBgImg ? activeBgImg: blue_body} alt="" />
                            </div>
                            <div className={styles.body_right}>
                                <img className={styles.bg_img} src={trapezoid_right} alt="" />
                                {
                                    rightOrgans.map((val: any, key: number) => (
                                        <div key={key} className={styles.right_trapezoid_wrap}  onClick = { () => { orgransActive(val, 'right') }}>
                                            <div className={styles.right_trapezoid}>
                                                <div className={styles.text} style={{
                                                    position: 'absolute',
                                                    left: '19.5px',
                                                    top: '50%',
                                                    transform: 'translate(0, -50%)',
                                                    zIndex: 2,
                                                    display: 'inline-block',
                                                    width: `${renderIconWidth(val)}px`,
                                                    height: `${renderIconHeight(val)}px`,
                                                    WebkitMaskImage: `url(${val.icon})`,
                                                    WebkitMaskSize: 'contain',
                                                    backgroundColor: val.selected ? colors.white : val.selectedCount ? colors.blue : colors.purple,
                                                    maskImage: `url(${val.icon})`,
                                                    maskSize: 'contain',
                                                }}>
                                                </div>
                                                <div className={`${styles.right_text}`} style={{ color: val.selected ? colors.white : val.selectedCount ? colors.blue : colors.purple}}>
                                                    {val.name}
                                                </div>
                                                <div className={`${styles.right_item_triangle} ${val.selected ? styles.item_selected_triangle : ''}`}>
                                                </div>
                                                <div className={`${styles.right_item_rect_base} ${styles['right_item_rect' + key ]} ${val.selected ? styles.item_selected_rect : ''}`}>
                                                    <div className={organsMap[val.code]?.selectedCount ? styles.count_bg : styles.count_bg_none}>{organsMap[val.code]?.selectedCount ? organsMap[val.code]?.selectedCount : ''}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className={styles.tip_bottom_wrap} style={{ opacity: selectedCount > 0 ? 1 : 0.5 }} onClick={toComplete}>
                        <img className={styles.bootom_top} src={btn_six_side} alt="" />
                        <div className={styles.bootom_top_text}>{
                        selectedCount == 0
                        ?
                        '请先选择症状后再进行下一步'
                        :
                        `已选择 ${selectedCount} 个症状、进入下一步`
                        }</div>
                    </div>
                    {
                        selectedCount > 0 &&
                        <div className={styles.symptoms_selected}>
                            <div className={styles.symptoms_top}></div>
                            <div className={styles.symptoms_bottom}>
                                {
                                    allSymptoms && allSymptoms.map((val: any, key: number) => (
                                        <div key={key}>
                                            {val.name}
                                            <img src={rt_delete_arrow} onClick={ () => { toDeleteSymptom(val) }} alt="" />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            }
            {
                showSurvey && 
                <Survey investigationComplete={onInvestigationComplete} />
            }
            {
                showDegree &&
                <Degree
                    investigation={investigation}
                    allSymptoms={allSymptoms}
                    treatments={treatments}
                    onBack={onBack}
                    onComplete={onDegreeComplete} 
                    allComplete={allComplete} 
                />
            }
            {
                showCompleted &&
                <Completed 
                    symptomRecords={symptomRecords}
                    treatments={treatments}
                    onBack={onBack}
                    onCompletedFinished={onCompletedFinished}
                />
            }
            {
                showResult &&
                <Result 
                    symptomsResult={symptomsResult}
                    onBack={onBack}
                />
            }
            {
                showOtherDialog &&
                <InputDialog onClose={onClose} onSave={onSave} placeholder={otherDialogPlaceholder}  />
            }
        </div>
    )
}

export default withRouter(AlkReport);